import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
export function _ownExposures(instanceId, api) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return memo(instanceId, function (accountId, eras, _withActive) {
    return eras.length ? api.queryMulti([].concat(_toConsumableArray(eras.map(function (era) {
      return [api.query.staking.erasStakersClipped, [era, accountId]];
    })), _toConsumableArray(eras.map(function (era) {
      return [api.query.staking.erasStakers, [era, accountId]];
    })))).pipe(map(function (all) {
      return eras.map(function (era, index) {
        return {
          clipped: all[index],
          era: era,
          exposure: all[eras.length + index]
        };
      });
    })) : of([]);
  });
}
export function ownExposure(instanceId, api) {
  return memo(instanceId, function (accountId, era) {
    return api.derive.staking._ownExposures(accountId, [era], true).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          first = _ref2[0];

      return first;
    }));
  });
}
export function ownExposures(instanceId, api) {
  return memo(instanceId, function (accountId) {
    var withActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return api.derive.staking.erasHistoric(withActive).pipe(switchMap(function (eras) {
      return api.derive.staking._ownExposures(accountId, eras, withActive);
    }));
  });
}